import { render, staticRenderFns } from "./import_pdfs_step_2.vue?vue&type=template&id=3c7b860a&scoped=true&"
import script from "./import_pdfs_step_2.vue?vue&type=script&lang=js&"
export * from "./import_pdfs_step_2.vue?vue&type=script&lang=js&"
import style0 from "./import_pdfs_step_2.vue?vue&type=style&index=0&id=3c7b860a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7b860a",
  null
  
)

export default component.exports